import React, { useState, useEffect } from 'react';
import { Card, Table, Badge, Spinner, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { CHUYENDETIENSI_API, BaseGatewayImage } from '../../../../utils/apiUrl';
import { trangThaiChuyenDeValue, objectLoaiChuyenDe } from '../../../../utils/define';
import { Get } from '../../../../utils/httpProvider';
import moment from 'moment';
import ChamChuyenDeModal from './ChamChuyenDeModal';

const ChuyenDeTienSi = ({ hoSoId }) => {
    const [viewMode, setViewMode] = useState('list');
    const [dataEdit, setDataEdit] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    
    const { isLoading, data: queryData, refetch } = useQuery(
        ['chuyenDeTienSiData', hoSoId],
        () => Get(`${CHUYENDETIENSI_API.GET_BY_HOSO_ID}/${hoSoId}`),
        { 
            enabled: !!hoSoId && viewMode === 'list',
            keepPreviousData: true
        }
    );

    // Xử lý data từ API
    let dataList = [];
    if (queryData) {
        if (Array.isArray(queryData)) {
            dataList = queryData;
        } else if (queryData.data && Array.isArray(queryData.data)) {
            dataList = queryData.data;
        } else if (queryData.data?.$values) {
            dataList = queryData.data.$values;
        } else {
            dataList = [queryData];
        }
    }

    useEffect(() => {
        if (dataList && dataList.length > 0) {
            setSelectedRow(prev => {
                if (prev) {
                    const fresh = dataList.find(item => item.id === prev.id);
                    return fresh || dataList[0];
                }
                return dataList[0];
            });
        } else {
            setSelectedRow(null);
        }
    }, [dataList]);

    const renderTrangThai = (val) => {
        switch (val) {
            case trangThaiChuyenDeValue.chuaThucHien: return <Badge variant="warning">Chưa thực hiện</Badge>;
            case trangThaiChuyenDeValue.dangThucHien: return <Badge variant="info">Đang thực hiện</Badge>;
            case trangThaiChuyenDeValue.hoanThanh: return <Badge variant="success">Hoàn thành</Badge>;
            default: return <Badge variant="secondary">Chưa xác định</Badge>;
        }
    };

    const renderLoaiChuyenDe = (val) => {
        const found = objectLoaiChuyenDe.find(x => x.value === val || x.value == val);
        return found ? found.label : '';
    };

    const renderTooltip = (props, text) => (
        <Tooltip id="button-tooltip" {...props}>
            {text}
        </Tooltip>
    );

    return (
        <>
        <Card className="card-sticky-layout">
            <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="font-weight-bold text-primary m-0">Chuyên đề tiến sĩ</h5>
                </div>
            </Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div className="text-center p-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <>
                        <div className="table-responsive">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th className="text-center" width="50">STT</th>
                                        <th>Loại chuyên đề</th>
                                        <th>Tên chuyên đề</th>
                                        <th className="text-center">Từ ngày</th>
                                        <th className="text-center">Đến ngày</th>
                                        <th className="text-center">Trạng thái</th>
                                        <th className="text-center">File ký ban hành</th>
                                    </tr>
                                </thead>
                            <tbody>
                                {dataList.length > 0 ? (
                                    dataList.map((item, index) => (
                                        <tr 
                                            key={item.id}
                                            onClick={() => setSelectedRow(item)}
                                            style={{ cursor: 'pointer' }}
                                            className={selectedRow?.id === item.id ? 'table-primary' : ''}
                                        >
                                            <td className="text-center">{index + 1}</td>
                                            <td>{renderLoaiChuyenDe(item.loaiChuyenDe)}</td>
                                            <td>{item.tenChuyenDe}</td>
                                            <td className="text-center">
                                                {item.tuNgay ? moment(item.tuNgay).format('DD/MM/YYYY') : ''}
                                            </td>
                                            <td className="text-center">
                                                {item.denNgay ? moment(item.denNgay).format('DD/MM/YYYY') : ''}
                                            </td>
                                            <td className="text-center">{renderTrangThai(item.trangThai)}</td>
                                            <td className="text-center">
                                                {item.fileKy ? (
                                                    (() => {
                                                        const path = item.fileKy;
                                                        const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
                                                        const safePath = path.startsWith('/') ? path : `/${path}`;
                                                        const fileUrl = path.startsWith('http') ? path : `${baseUrl}${safePath}`;
                                                        let name = path.split('/').pop() || 'File';
                                                        name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                                                        return (
                                                            <a href={fileUrl} target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-sm text-left mb-1 mr-1" style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                                                <i className="fas fa-paperclip mr-1"></i> {name}
                                                            </a>
                                                        );
                                                    })()
                                                ) : (
                                                    <span className="text-muted">Không có</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted">
                                            Chưa có dữ liệu Chuyên đề tiến sĩ (chỉ hiển thị khi Phòng HLĐT tạo chuyên đề)
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                        </div>
                    </>
                )}
            </Card.Body>
            {!isLoading && (
                <Card.Footer className="bg-white card-footer-sticky">
                    <div className="d-flex justify-content-end pr-4">
                        <Button 
                            variant="info" 
                            size="sm" 
                            onClick={() => { setDataEdit(selectedRow); setViewMode('chamChuyenDe'); }} 
                            className="mr-2 text-white"
                            disabled={!selectedRow}
                        >
                            <i className="fas fa-check-double mr-1"></i> Kết quả chấm chuyên đề
                        </Button>
                    </div>
                </Card.Footer>
            )}
        </Card>

        {viewMode === 'chamChuyenDe' && dataEdit && (
            <ChamChuyenDeModal
                dataEdit={dataEdit}
                setViewMode={setViewMode}
                isView={true}
                isUserView={true}
            />
        )}
        </>
    );
};

export default ChuyenDeTienSi;
